<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--right" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"><path d="m14.32 12.518-6.284 6.16.84.822L16 12.518 8.84 5.5 8 6.323l6.32 6.194Z" fill="#1A1A1E"/></svg>
</template>